export const TranslationsVI = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Đặt Hàng',
        cart: 'Giỏ Hàng',
        open_24: '24 Giờ',
        closed: 'Đóng',
        free: 'MIỄN PHÍ',
        something_went_wrong: 'có lỗi xảy ra',
        try_again: 'thử lại',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Thứ Hai',
                tuesday: 'Thứ Ba',
                wednesday: 'Thứ Tư',
                thursday: 'Thứ Năm',
                friday: 'Thứ Sáu',
                saturday: 'Thứ Bảy',
                sunday: 'Chủ Nhật',
            },
        },
        services: {
            pickup: 'Đến Mang Đi',
            delivery: 'Giao Tận Nơi',
            dine_in: 'Dùng Tại Cửa Hàng',
            table_booking: 'Đặt Bàn',
        },
        payment: {
            method: {
                cash: 'Tiền Mặt',
                card: 'Thẻ',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Lựa Chọn Khác',
            },
            backend_method: {
                cash: 'Tiền Mặt',
                card: 'Thẻ',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                custom: 'Lựa Chọn Khác',
            },
            status: {
                success: 'Thành Công',
                pending: 'Đang Chờ',
                error: 'Lỗi',
                refunded: 'Đã Hoàn Tiền',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Xóa',
                drop_here: 'Thả files vào đây hoặc click chọn',
                accepts: 'Chấp nhận các loại files {{fileTypes}}',
                errors: {
                    max_files: 'Tối đa {{number}} files',
                    max_size: 'Dung lượng file tối đa {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Cửa hàng đang trong giờ đóng cửa nên không thể phục vụ bạn ngay lúc này. Bạn có thể đặt trước cho thời gian tới',
            },
            buttons: {
                order: {
                    book_order: 'Đặt Chỗ / Đặt Online',
                    order_online: 'Đặt Hàng',
                    book_table: 'Đặt 1 Bàn',
                    order: 'Đặt Hàng',
                    book: 'Đặt Chỗ',
                    cart: 'Giỏ Hàng',
                    restart: 'Làm Lại Từ Đầu',
                    closed: 'Cửa Hàng Đang Đóng',
                    not_accepting: 'Không Nhận Đơn',
                },
            },
        },
        modals: {
            auth: {
                login: 'Đăng Nhập',
                register: 'Đăng Ký',
                register_commence: 'Tiếp Tục',
                register_complete: 'Tạo Tài Khoản',
                register_confirmation_sent: 'Mã xác nhận đã được gởi đến hộp mail của bạn. Vui lòng nhập mã để tiếp tục',
                register_confirmation_resent: 'Mã xác nhận đã được gởi lại, hãy kiểm tra danh sách thư rác và tiếp tục lại',
                register_restart: 'Làm Lại',
                register_resend_code: 'Gởi Lại Mã',
                login_placeholder: 'Địa Chỉ Mail',
                password_placeholder: 'Mật Khẩu',
                confirm_password_placeholder: 'Xác Nhận Mật Khẩu',
                confirmation_code_placeholder: 'Mật Khẩu Xác Nhận Qua Mail',
                accept_terms: 'Đồng Ý Các Điều Kiện',
                accept_terms_view: 'Xem',
                login_facebook: 'Đăng Nhập Bằng Facebook',
                login_google: 'Đăng Nhập Bằng Google',
                benefits: 'Đăng nhập hoặc tạo tài khoản để lưu lại tất cả giao dịch',
                logged_in: 'Đăng Nhập Thành Công',
                logged_out: 'Đã Đăng Xuất',
                password_reset: {
                    init_button: 'Gởi Mail Tạo Lại Mật Khẩu Mới',
                    init_success: 'Liên kết tạo mật khẩu mới đã được gởi vào mail của bạn',
                    complete_button: 'Tạo Lại Mật Khẩu',
                    complete_success: 'Mật khẩu mới được tạo thành công, đăng nhập bằng mật khẩu mới',
                    forgot_password_text: 'Quên mật khẩu? ',
                    forgot_password_link: 'Tạo lại mật khẩu',
                    remember_password_text: 'Ghi nhớ mật khẩu? ',
                    remember_password_link: 'Quay lại',
                    invalid_title: 'Tạo Lại Mật Khẩu Không Khả Dụng',
                    invalid_description: 'Liên kết tạo lại mật khẩu không khả dụng, yêu cầu một liên kết mới',
                    invalid_link: 'Đi Đến Đăng Nhập',
                    title: 'Tạo Lại Mật Khẩu',
                    description: 'Nhập một mật khẩu mới cho tài khoản của bạn',
                },
                error_generic: 'Có lỗi xảy ra, hãy thử lại hoặc liên hệ chúng tôi',
                error_accept_terms: 'Vui lòng chấp nhận các điều khoản & điều kiện',
                error_password_length: 'Mật khẩu có độ dài tối thiểu 6 ký tự',
                error_social: 'Có lỗi xảy ra, hãy thử lại hoặc liên hệ chúng tôi',
                error_confirmation_code: 'Mã xác nhận không khả dụng',
                error_invalid_code: 'Mã xác nhận không khả dụng',
                error_exists: 'Tên đăng nhập đã tồn tại',
                error_invalid_email_pass: 'Địa chỉ mail hoặc mật khẩu không đúng',
                error_password_no_match: 'Mật khẩu không khớp',
                error_user_not_found: 'Không có người dùng với địa chỉ mail này',
                error_invalid_email: 'Địa chỉ mail không khả dụng',
                error_invalid_reset_token: 'Liên kết tạo lại không khả dụng, yêu cầu liên kết khác',
            },
            booking: {
                form: {
                    name: 'Họ Và Tên',
                    email: 'Địa Chỉ Mail',
                    phone: 'Số Điện Thoại',
                    number_of_people: 'Số Khách',
                    number_of_people_max: 'Tối Đa ({{max_people}} Khách)',
                    number_of_people_min: 'Tối Thiểu ({{min_people}} Khách)',
                    number_of_people_max_min: 'Số Khách (Từ {{min_people}} tới {{max_people}})',
                    notes: 'Lưu Ý / Yêu Cầu Đặc Biệt',
                    submit: 'Gởi Yêu Cầu Đặt Bàn',
                    email_optional: '(không bắt buộc)',
                    date: 'Ngày',
                    duration: 'Thời lượng',
                    seating: 'Khung giờ trống',
                    number_of_guests: 'Số khách',
                    notes_placeholder: 'Dị ứng, dịp, vị trí ngồi mong muốn',
                    reserving: 'Đang đặt bàn...',
                    reserve_table: 'Đặt bàn',
                    please_choose_a_date_and_time: 'Vui lòng chọn ngày và giờ.',
                    invalid_people: 'Số người phải từ {{min}} đến {{max}}.',
                    party_size_max_fallback: 'mức tối đa cho phép',
                    loading_available_times: 'Đang tải khung giờ trống…',
                    select_a_date_to_see_available_times: 'Chọn ngày để xem khung giờ trống.',
                    no_times_available_for_this_date: 'Không có khung giờ trống cho ngày này. Vui lòng chọn ngày khác.',
                    shift: 'Ca',
                    service_times: 'Giờ phục vụ',
                    new_shift: 'Ca mới',
                    time: 'khung giờ',
                    times: 'khung giờ',
                    unavailable: 'Hết chỗ',
                    available: 'Còn chỗ',
                    required_name: 'Vui lòng nhập tên của bạn.',
                    required_phone: 'Vui lòng nhập số điện thoại.',
                    required_email: 'Vui lòng nhập email.',
                    invalid_email: 'Vui lòng nhập email hợp lệ.',
                    required_terms: 'Vui lòng chấp nhận điều khoản trước khi đặt bàn.',
                    missing_custom_fields: 'Vui lòng trả lời tất cả câu hỏi bắt buộc.',
                    reservation_is_unavailable: 'Không thể đặt bàn.',
                    please_contact_the_restaurant_directly: 'Vui lòng liên hệ trực tiếp nhà hàng.',
                    almost_done: 'Sắp xong',
                    your_details: 'Thông tin của bạn',
                    tell_us_who_s_coming: 'Cho chúng tôi biết ai sẽ đến để xác nhận đặt bàn.',
                    book_your_table: 'Đặt bàn của bạn',
                    choose_a_time_that_works_for_you: 'Chọn khung giờ phù hợp với bạn.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Gửi yêu cầu đặt bàn và nhà hàng sẽ lo phần còn lại.',
                    select_date: 'Chọn ngày',
                    standard: 'Tiêu chuẩn',
                    minutes: 'phút',
                    next: 'Tiếp →',
                    back: '← Quay lại',
                    accept_terms: 'Tôi chấp nhận các điều khoản và điều kiện.',
                    info_1: 'Bạn sẽ nhận được mail thông báo khi yêu cầu đặt chỗ của bạn được chấp nhận hoặc từ chối',
                },
                errors: {
                    not_found: 'Đặt chỗ không tồn tại. Có thể chỗ đã bị xóa',
                    generic: 'Có lỗi xảy ra, hãy tải lại trang hoặc liên hệ chúng tôi',
                    something_went_wrong: 'Có lỗi xảy ra',
                    accept_terms: 'Vui lòng đồng ý các điều khoản và điều kiện',
                    required_phone: 'Vui lòng nhập số điện thoại',
                    required_email: 'Vui lòng nhập mail của bạn',
                    required_name: 'Vui lòng nhập tên bạn',
                    invalid_email: 'Vui lòng nhập một địa chỉ mail có thật',
                    invalid_phone: 'Vui lòng nhập một số điện thoại có thật',
                    invalid_people: 'Số khách không khả dụng',
                    booking_capacity_threshold: 'Khung giờ này đã hết chỗ. Vui lòng thử khung giờ khác.',
                    slot_unavailable: 'Số người này đã hết chỗ. Vui lòng thử khung giờ khác.',
                    booking_date_paused: 'Đặt bàn tạm dừng cho ngày này. Vui lòng chọn ngày khác.',
                    invalid_table_assignment: 'Những bàn đó không đủ chỗ cho nhóm của bạn. Vui lòng chọn giờ khác.',
                    exceeded_order_limit: 'Quá nhiều yêu cầu đặt bàn. Vui lòng thử lại sau.',
                    validation_failed_recaptcha_v3: 'Phát hiện lưu lượng bất thường. Bạn có đang dùng VPN không? Hoàn tất xác minh ở trên và thử lại.',
                    validation_failed_recaptcha_v2: 'Không thể bắt đầu đặt bàn. Vui lòng thử lại hoặc dùng cách khác. Nếu bạn đang dùng VPN, hãy thử tắt trước.',
                    booking_already_exists: 'Đặt bàn này đã được gửi. Kiểm tra email hoặc mở liên kết đặt bàn của bạn.',
                    invalid_party_size: 'Vui lòng chọn số người hợp lệ.',
                    invalid_request: 'Yêu cầu không hợp lệ. Vui lòng tải lại trang và thử lại.',
                    table_booking_unavailable: 'Đặt bàn không khả dụng.',
                },
            },
            cart: {
                title: 'Giỏ Hàng',
                proceed_to_checkout: 'Tiến Hành Thanh Toán',
                edit_dish: 'Sửa',
                remove_dish: 'Xóa',
                no_items_1: 'Không có hàng trong giỏ hàng',
                no_items_2: 'Trước tiên, thêm vài thứ vào rồi tiếp tục',
                free_delivery_notice: 'Miễn phí giao hàng với đơn hàng trên {{value, currency}}',
                errors: {
                    min_order_promo: 'Đơn hàng tối thiểu {{value, currency}} sẽ được hưởng ưu đãi này',
                    min_order_delivery: 'Đơn hàng tối thiểu {{value, currency}} để giao đi',
                },
                promo: {
                    heading: 'Mã Ưu Đãi',
                    placeholder: 'Nhập mã ưu đãi',
                    add: 'Thêm Mã',
                    title: 'Ưu đãi {{name}} đã được áp dụng cho đơn hàng',
                    fixed_discount: 'Giảm Giá {{value, currency}}',
                    percent_discount: 'Giảm Giá {{value}}%',
                    added_to_cart: 'Ưu đãi đã được áp dụng cho đơn hàng',
                    errors: {
                        not_found: 'Không tìm thấy ưu đãi',
                        disabled: 'Ưu đãi không hiệu lực',
                        not_available: 'Ưu đãi hiện tại không khả dụng',
                        logged_in_only: 'Phải đăng nhập để sử dụng ưu đãi này',
                        already_used: 'Bạn đã sử dụng ưu đãi này rồi',
                        invalid: 'Ưu đãi này không còn khả dụng',
                        invalid_service: 'Ưu đãi này không khả dụng cho dịch vụ bạn đang chọn',
                        later_only: 'Chỉ sử dụng cho đặt trước hẹn giờ',
                        now_only: 'Chỉ sử dụng cho đặt giao ngay, không dùng cho đặt trước hẹn giờ',
                        generic: 'Ôi... có lỗi xảy ra và đã được ghi dấu lại',
                        dishes_required_multi: 'Ưu đãi này chỉ áp dụng khi có một số món nhất định được thêm vào giỏ hàng',
                        dishes_required_single: "Ưu đãi này chỉ áp dụng cho món '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Tiền Boa Cho Shipper',
                    placeholder: 'Nhập vào số tiền boa',
                },
            },
            checkout: {
                title: 'Thanh Toán',
                subtitle: 'Xác nhận đơn hàng',
                details: {
                    service: 'Dịch Vụ',
                    due: 'Giờ Hẹn',
                    due_now_asap: 'Liền / Càng Sớm Càng Tốt',
                    address: 'Địa Chỉ Giao Đến',
                    total: 'Tổng',
                    table: 'Bàn',
                    store_location: 'Địa Chỉ Cửa Hàng',
                },
                customer: {
                    title: 'Khách',
                    subtitle: 'Đăng nhập để lưu lại các giao dịch',
                    button: 'Đăng Nhập',
                    name: 'Họ Và Tên',
                    email: 'Địa Chỉ Mail',
                    phone: 'Số Điện Thoại',
                    phone_important: 'Số Điện Thoại (Quan Trọng)',
                    notes: 'Ghi Chú Đơn Hàng',
                    delivery_notes: 'Hướng Dẫn Giao Hàng / Ghi Chú Đơn Hàng',
                    optional: 'Tùy Chọn',
                },
                payment: {
                    title: 'Cách Thanh Toán',
                },
                accept_terms: 'Đồng Ý Các Điều Kiện',
                accept_terms_view: 'Xem',
                processing_order: 'Đơn Đang Xử Lý',
                warning: {
                    different_payment_currency: 'Giá tính bằng {{store_currency}} nhưng thanh toán sử dụng {{payment_currency}}',
                    closing_soon: 'Gần tới giờ đóng cửa, đơn hàng cần được đặt trong vòng {{value}} phút',
                    closed: 'Xin lỗi, hiện tại đang ngoài khung giờ cho dịch vụ này nên đơn hàng không được chấp nhận',
                    expired: 'Chúng tôi không thể đáp ứng đơn hàng của bạn theo thời gian bạn đã chọn. Vui lòng chọn lại một thời điểm khác',
                },
                errors: {
                    stripe_generic: 'Lỗi thẻ tính dụng, hãy thử lại hoặc chọn cách khác',
                    stripe_loading_fail: 'Lỗi khi tải form thanh toán, vui lòng thử lại',
                    something_went_wrong: 'Có lỗi xảy ra',
                    paypal_generic: 'Có lỗi xảy ra với PayPal, hãy thử lại hoặc chọn cách thanh toán khác',
                    payment_fail: 'Thanh toán không thành công, hãy thử lại hoặc chọn cách thanh toán khác',
                    payment_cancelled: 'Thanh toán bị hủy bỏ, hãy thử lại hoặc chọn cách thanh toán khác',
                    payment_error: 'Lỗi khi thanh toán online, hãy thử lại hoặc chọn cách thanh toán khác',
                    payment_declined: 'Phương thức thanh toán bạn chọn bị từ chối',
                    card_declined: 'Thẻ của bạn bị từ chối nên không thể thanh toán',
                    promo_max_uses_exceeded: "Mã khuyến mãi này đã đạt giới hạn sử dụng và không còn khả dụng.",
                    store_closed: 'Cửa hàng đang trong giờ đóng cửa nên không nhận đơn nữa',
                    accept_terms: 'Vui lòng chấp nhận các điều khoản và điều kiện',
                    required_payment: 'Vui lòng chọn cách thanh toán',
                    required_phone: 'Vui lòng nhập số điện thoại',
                    required_email: 'Vui lòng nhập địa chỉ mail',
                    required_name: 'Vui lòng nhập tên bạn',
                    invalid_email: 'Vui lòng nhập một địa chỉ mail có thật',
                    invalid_phone: 'Vui lòng nhập một số điện thoại có thật',
                    invalid_cc_number: 'Thẻ tín dụng của bạn không khả dụng',
                    invalid_order_amount: 'Số tiền tối thiểu cần thiết cho phương thức thanh toán này',
                    retry_cc_number: 'Có lỗi xảy ra, hãy nhập lại số thẻ và thử lại',
                    closed: 'Cửa hàng đang trong giờ đóng cửa hoặc sắp đóng cửa nên không nhận thêm đơn nữa',
                    promo_login_required: 'Phải đăng nhập để sử dụng ưu đãi này',
                    promo_used: 'Bạn đã sử dụng ưu đãi này',
                },
                button: {
                    continue: 'Tiếp Tục Tới Thanh Toán',
                    place_order: 'Đặt Hàng',
                },
            },
            customer: {
                age_v: {
                    title: 'Xác Nhận Tuổi',
                    required_for_items: 'Được Yêu Cầu cho vài món nhất định',
                    min_age: 'Tối thiểu: {{age}} tuổi',
                    est_time: 'Thời gian duyệt khoản: {{time}} giờ',
                    upload_description: 'Tải lên CMT/bằng lái của bạn ngay đây để được xác nhận. Bạn sẽ nhận được thông báo qua mail khi được duyệt. Tải lên tối đa 2 ảnh, mỗi ảnh có dung lượng dưới 2 MB',
                    pending_description_1: 'Cám ơn bạn đã gởi tài liệu để xác nhận. Bạn sẽ nhận được thông báo qua mail khi được duyệt',
                    pending_description_2: 'Tải lại trang để cập nhật tình trạng duyệt. Thời gian duyệt khoản {{time}} giờ',
                    approved_description: 'Tài khoản của bạn đã được xác nhận, giờ đây bạn có thể đặt những món trong thực đơn giới hạn',
                    rejected_description: 'Tài liệu của bạn đã bị từ chối. Nếu bạn muốn thử lại, vui lòng tải lên lại tài liệu',
                    upload: 'Tải Lên',
                    reupload: 'Tải Lên Lại Tài Liệu Để Xác Nhận',
                    go_back: 'Quay Lại',
                    view_document: 'Xem CMT/bằng lái {{number}}',
                    status: {
                        unverified: 'Chưa được xác nhận',
                        pending: 'Đang Chờ Duyệt',
                        approved: 'Xác Nhận Thành Công',
                        rejected: 'Bị Từ Chối',
                    },
                },
                headings: {
                    sessions: 'Phiên Đăng Nhập',
                    orders: 'Đơn Hàng',
                    spend: 'Đã Chi',
                    order_history: 'Các Giao Dịch Trước',
                    loyalty_points: 'Điểm khách hàng',
                },
            },
            custom_payment: {
                title: 'Form Thanh Toán {{name}}',
                description: 'Bạn đang dùng form thanh toán online. Vui lòng hoàn tất các mục bên dưới để thanh toán. Nếu không có số tiền nào nhập vào, thông tin của bạn sẽ được lưu lại nhưng chưa trả tiền.',
                disabled: 'Trang thanh toán online này chưa được thiết lập xong. Vui lòng liền hệ quản lý website để giải quyết vấn đề.',
                success: 'Thanh toán đã được xử lý thành công và thông tin của bạn đã được lưu lại. Xin cám ơn',
                back: 'Quay Lại Trang Chính',
                fields: {
                    name: 'Họ Và Tên',
                    email: 'Địa Chỉ Mail',
                    reference: 'Mã Thanh Toán',
                    amount: 'Số Tiền (đ)',
                    name_on_card: 'Tên Trên Thẻ',
                    submit: 'Gởi Thanh Toán',
                },
                warning: {
                    currency: 'Lưu ý: Thanh toán bằng {{actual}}, không phải {{default}}',
                },
                errors: {
                    generic: 'Có lỗi xảy ra, hãy thử lại hoặc liên hệ chúng tôi',
                    stripe_generic: 'Lỗi thẻ tín dụng, hãy tải lại trang và thử lại',
                    payment_fail: 'Thanh toán không thành công, vui lòng thử lại hoặc chọn cách thanh toán khác',
                    payment_cancelled: 'Thanh toán bị hủy bỏ, vui lòng thử lại hoặc chọn cách thanh toán khác',
                    payment_error: 'Lỗi khi xử lý thanh toán online, hãy thử lại hoặc chọn cách thanh toán khác',
                    payment_declined: 'Cách thanh toán bạn chọn đã bị từ chối',
                    card_declined: 'Thẻ của bạn đã bị từ chối nên thanh toán chưa được xử lý',
                    promo_max_uses_exceeded: "Mã khuyến mãi này đã đạt giới hạn sử dụng và không còn khả dụng.",
                },
            },
            dish: {
                add: 'Thêm Vào Giỏ Hàng',
                edit: 'Sửa',
                notes: 'Đặc biệt lưu ý...',
                ingredients: {
                    title: 'ĐÃ CÓ SẴN TRONG MÓN NÀY',
                    uncheck_remove: 'Tắt để KHÔNG LẤY loại nào đó',
                },
                ingredients_title: 'Thành Phần Có Sẵn',
                combo: {
                    choose_dish: 'Chọn Một Món',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Chọn một (Bắt Buộc)',
                        select_one_optional: 'Chọn một (Tùy Chọn)',
                        select_between: 'Chọn Từ {{min}} Đến {{max}} (Bắt Buộc)',
                        select_at_least: 'Chọn ít nhất {{qty}} (Bắt Buộc)',
                        select_up_to: 'Chọn tới tối đa {{qty}} (Tùy Chọn)',
                        select_multiple: 'Chọn nhiều (Tùy Chọn)',
                        free_amount: 'Miễn Phí {{qty}} Đầu Tiên / {{selected}} Được Chọn',
                    },
                },
                error: 'Vui lòng xem lại những chỗ đánh dấu đỏ',
                added_to_cart: 'Món Đã Được Thêm Vào Giỏ',
            },
            map: {
                zone_fee: 'Phí Giao Hàng',
                view_in_google: 'Xem Trên Bản Đồ Google',
            },
            portal_go_back: {
                title: 'Quay Lại Mục Tìm Kiếm Nhà Hàng?',
                description: 'Tất cả món trong giỏ hàng sẽ bị mất',
                cancel: 'Hủy',
                proceed: 'Quay Lại',
            },
            order: {
                config: {
                    services: {
                        title: 'Chọn Một Dịch Vụ',
                        table_booking: 'Đặt Bàn',
                    },
                    address_custom: {
                        input_placeholder: 'Nhập địa chỉ giao đến',
                    },
                    address: {
                        input_placeholder: 'Nhập Địa Chỉ Giao Đến',
                        extras_placeholder: 'Tòa nhà, hướng dẫn giao hàng, v.v...',
                        search_placeholder: 'Tìm Địa Chỉ Giao Đến',
                        not_found: 'Không tìm thấy địa chỉ giao đến, hãy thử lại',
                        not_delivering: 'Hiện tại chúng tôi chưa giao đến khu vực này',
                        not_in_range: 'Địa chỉ của bạn không nằm trong phạm vi triển khai của dịch vụ này',
                        not_in_zone: 'Địa chỉ của bạn không nằm trong vùng giao hàng',
                    },
                    datetime: {
                        title: 'Bạn Muốn Giao Vào Lúc Nào',
                        due_now: 'Ngay Bây Giờ',
                        due_later: 'Hẹn Giờ Giao',
                        service_not_available: 'Xin lỗi, chúng tôi hiện không nhận thêm đơn cho dịch vụ {{service}}',
                        currently_closed: 'Dịch vụ {{service}} hiện đang đóng nhưng bạn có thể đặt trước',
                        due_unavailable: 'Không Có Sẵn',
                        due_closed: 'Đã Đóng',
                        select_date: 'Chọn Ngày',
                        select_time: 'Chọn Giờ',
                        select_order_date: 'Chọn Ngày Đặt',
                        select_order_time: 'Chọn Giờ Đặt',
                        select_booking_date: 'Chọn Ngày Đặt Bàn',
                        select_booking_time: 'Chọn Giờ Đặt Bàn',
                        no_times_available: 'Không có thời gian nào để chọn',
                        date_today: '(Hôm Nay)',
                        date_closed: '(Đã Đóng)',
                        date_bookings_paused: '(Đặt bàn tạm dừng)',
                        time_slot_closed: 'Đã Đóng',
                    },
                    number_of_people: {
                        placeholder: 'Số Khách',
                    },
                    table: {
                        select: 'Chọn Bàn',
                        select_popup_title: 'Chọn Bàn Của Bạn',
                        password: 'Mã Bàn',
                        password_warning: 'Nhập mã bàn để tiến hành',
                    },
                    warning: {
                        closed: 'Xin lỗi, chúng tôi hiện đang đóng / không nhận thêm đơn',
                        not_available: 'Xin lỗi, chúng tôi hiện không nhận thêm đơn',
                    },
                    start_button: 'Bắt Đầu Đặt',
                },
                history: {
                    invalid: 'Không thể đặt lại theo đơn cũ vì có món đã được cập nhật hoặc có món không còn tồn tại',
                },
                reorder: {
                    title: 'Đặt Lại Nhanh',
                    description: 'Dễ dàng đặt lại đơn hàng y như những đơn trước',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Không tìm thấy đơn hàng, hãy tải lại trang và thử lại',
                    booking_not_found: 'Đặt bàn không tồn tại. Có thể đã bị xóa',
                    generic: 'Có lỗi xảy ra, hãy tải lại trang hoặc liên hệ chúng tôi',
                },
                connection: {
                    connected: 'Đang xử lý',
                    connecting: 'Đang kết nối trạng thái đơn',
                    disconnected: 'Trạng thái đơn đang bị ngắt kết nối',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Cảnh Báo',
                    title: 'Đăng Xuất',
                    body: 'Việc đăng xuất sẽ xóa tất cả món mà bạn đã thêm vào giỏ hàng trước đó',
                    cancel: 'Hủy',
                    proceed: 'Tiến Hành',
                },
                order_restart: {
                    warning: 'Cảnh Báo',
                    title: 'Thay Đổi Chi Tiết Đơn Hàng',
                    body: 'Thay đổi chi tiết đơn hàng sẽ xóa tất cả món trong giỏ hàng khi có một món nào đó đã hết',
                    cancel: 'Hủy',
                    proceed: 'Tiến Hành',
                },
                order_expired: {
                    subtitle: 'Quan Trọng',
                    title: 'Tình trạng đơn chuyển thành CẦN THỰC HIỆN NGAY',
                    description: 'Thời gian đặt đơn của bạn đã gần hết. Tình trạng đơn được chuyển thành CẦN THỰC HIỆN NGAY / CÀNG SỚM CÀNG TỐT',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Quan Trọng',
                    title: 'Thời Gian Đặt Đơn Sắp Hết',
                    description: 'Đơn hàng của bạn cần được đặt trước {{time, timeFromTimestamp}}, sau thời gian đó đơn không còn khả dụng',
                    button: 'Ok',
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Khách",
                login: "Đăng Nhập",
                login_signup: "Đăng Nhập / Đăng Ký",
                logout: "Đăng Xuất",
            },
            menus: {
                info: {
                    no_menus: "Hiện tại chưa có menu",
                    restrictions: "Thực Đơn Giới Hạn",
                    not_available: "Hiện Tại Menu Chưa Có Sẵn",
                    unavailable: {
                        times: "Thực đơn không có, yêu cầu về đơn hàng của bạn không khớp",
                        services: "Thực đơn không có, yêu cầu về đơn hàng của bạn không khớp",
                        hours: "Thực đơn không có, giờ đặt hàng của bạn không khớp với giờ phục vụ trên menu",
                        pre_order: "Thực đơn không có, đơn hàng của bạn không khớp với yêu cầu về việc đặt trước",
                        age: "Thực đơn không có, bạn phải đăng nhập và xác nhận tuổi để đặt hàng trên menu này",
                    },
                    services: {
                        title: "Yêu Cầu Cho Đơn Hàng",
                        pickup: "Đến Mang Đi",
                        delivery: "Giao Tận Nơi",
                        dine_in: "Dùng Tại Cửa Hàng",
                    },
                    times: {
                        now: "Không đơn đặt lại",
                        later: "Chỉ đơn đặt lại",
                    },
                    hours: {
                        title: "Giờ Phục Vụ",
                    },
                    preorder: {
                        title: "Yêu Cầu Về Việc Đặt Trước",
                        days_in_advance: "Phải đặt trước {{days}} ngày",
                        cutoff_time: "Thời hạn cuối lúc {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Tuổi Không Phù Hợp",
                        approved: "Tài khoản của bạn được xác nhận và bạn có thể đặt hàng trên menu này",
                        rejected: "Yêu cầu xác nhận tuổi để đặt hàng. Hãy tạo một tài khoản và tải lên CMT/bằng lái",
                    },
                },
                search: {
                    title: 'Khám phá thực đơn',
                    no_result: 'Không tìm thấy kết quả. Bạn muốn đổi tìm kiếm?.',
                    placeholder: 'Bạn đang muốn tìm gì từ thực đơn?'
                }
            },
            info: {
                location: {
                    title: "Địa Điểm",
                    view_map: "Xem Trên Bản Đồ",
                    phone: "Số Điện Thoại",
                },
                hours: {
                    title: "Giờ Mở Cửa",
                    title_special: "Giờ Mở Cửa Đặc Biệt",
                },
                services: {
                    title: "Dịch Vụ",
                    notes: "Lưu Ý",
                    delivery: {
                        ranges: "Phạm Vi Giao Hàng",
                        zones: "Khu Vực Giao Hàng",
                        view_zones: "Xem Khu Vực Giao Hàng Trên Bản Đồ",
                        fee: "Phí Giao Hàng",
                        fee_short: 'Phí',
                        fee_varies: "Tùy điều kiện, được hiển thị trong đơn hàng",
                        min_order: "Đơn Hàng Tối Thiểu",
                        min_order_short: 'ĐH tối thiểu',
                        no_min_order: "Không Yêu Cầu Đơn Hàng Tối Thiểu",
                        free_amount: "Hạn Mức Giao Hàng Miễn Phí",
                    },
                },
            },
            contact: {
                title: "Liên hệ với chúng tôi",
                name: "Tên",
                email: "E-mail",
                phone: "Số Điện Thoại",
                message: "Nhập nội dung...",
                send: "Gởi Tin",
                success: "Tin nhắn của bạn đã được gởi đi thành công",
                error: "Có lỗi xảy ra, hãy thử lại hoặc quay lại vào lúc khác",
            },
            footer: {
                powered_by: " ",
                terms_and_conditions: "Điều Khoản & Điều Kiện",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Hóa Đơn Đặt Bàn',
            details: {
                datetime: 'Đặt Bàn Cho',
                number_of_people: 'Số Khách',
                placed: 'Đã Đặt',
                updated: 'Cập Nhật Lần Cuối',
                notes: 'Lưu Ý',
                name: 'Tên',
                email: 'E-Mail',
                phone: 'Điện Thoại',
                store_address: 'Địa Chỉ Cửa Hàng',
            },
            status_update: {
                title: 'Cập Nhật Giao Dịch Đặt Bàn {{number}}',
                body: 'Trạng thái đặt bàn của bạn đã được chuyển thành {{status}}',
            },
            email_status_update_customer: {
                subject: 'Đặt bàn #{{number}} – {{subjectLabel}}',
                body: 'Đặt bàn #{{number}} của bạn tại {{store}} hiện là {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Đơn hàng #{{number}} – {{subjectLabel}}',
        header: 'Giờ sẵn sàng đã cập nhật',
        title: 'Giờ sẵn sàng đã cập nhật',
        order_number: 'Số thứ tự: {{number}}',
        description: 'Đơn hàng của bạn sẽ sẵn sàng lúc {{time}}.',
        order_time_updated_to: 'Giờ đơn hàng của bạn đã được cập nhật.',
        powered_by: 'cung cấp bởi {{name}}',
        button_text: 'Theo dõi thứ tự',
        subject_label: 'Giờ sẵn sàng đã cập nhật',
        subject_label_delivery: 'Giờ giao hàng đã cập nhật',
        body_ready: 'Đơn hàng của bạn sẽ sẵn sàng lúc {{time}}.',
        body_delivery: 'Đơn hàng của bạn sẽ được giao lúc {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Giờ Chuẩn Bị',
            est_driver_pickup_time: 'Giờ Khởi Hành',
            est_delivery_time: 'Giờ Giao Đến',
            tab_details: 'Chi Tiết',
            tab_dishes: 'Các Món',
            details: {
                status: 'Trạng Thái',
                placed: 'Đã Đặt',
                due: 'Giờ Hẹn',
                due_asap: 'Liền / Càng Sớm Càng Tốt',
                last_updated: 'Cập Nhật Lần Cuối',
                total: 'Tổng',
                type: 'Loại Dịch Vụ',
                table: 'Bàn',
                number_of_people: 'Số Khách',
                payment_method: 'Cách Thanh Toán',
                payment_status: 'Trạng Thái Thanh Toán',
                payment_currency: 'Loại Tiền Thanh Toán',
                notes: 'Lưu Ý',
                name: 'Tên',
                email: 'E-Mail',
                phone: 'Điện Thoại',
                distance: 'Quãng Đường',
                driving_time: 'Thời Gian Lái Xe',
                delivery_zone: 'Vùng',
                delivery_address: 'Địa Chỉ Giao Đến',
                delivery_tracking: 'Theo Dõi Giao Hàng',
                delivery_tracking_link: 'Link theo dõi trực tiếp',
                tookan_status: 'Trạng thái Tookan',
                tookan_status_failed_book: 'Đặt tài xế không thành công',
                tookan_status_failed_update: 'Cập nhật đặt tài xế không thành công',
                tookan_status_success: 'Đã đặt tài xế',
                store_address: 'Địa Chỉ Cửa Hàng',
            },
            dishes: {
                headings: {
                    quantity: 'S.Lượng',
                    item: 'Món',
                    price: 'Giá',
                },
                notes: 'Lưu Ý',
                remove_ingredients: 'Không Lấy',
            },
            status_update: {
                title: 'Cập Nhật Đơn {{number}}',
                body: 'Trạng thái đơn của bạn được chuyển thành {{status}}',
            },
            wait_time_update: {
                title: 'Cập Nhật Đơn {{number}}',
                body: 'Giờ hẹn đơn của bạn đã được cập nhật lại',
            },
            delivery_update: {
                title: 'Cập Nhật Đơn {{number}}',
                body: 'Đơn của bạn đã được chuyển đến shipper. Hãy xem link theo dõi trực tiếp',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Theo dõi đơn hàng",
                track_delivery_button_text: "Theo dõi giao hàng",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Theo dõi đơn hàng",
                track_delivery_button_text: "Theo dõi giao hàng",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "Giá đã bao gồm {{name}} ({{percent}}%)",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Phí Giao Hàng",
            promo: "Giảm Giá: {{name}} ({{value, currency}} + {{percent}}%)",
            promo_percent: "Giảm Giá: {{name}} ({{percent}}%)",
            promo_fixed: "Giảm Giá: {{name}}",
            promo_none: "Giảm Giá: {{name}}",
            cart: "Giỏ Hàng",
            tip: "Tiền Boa",
            total: "Tổng",
        },
        status: {
            unconfirmed: "Chưa Xác Nhận",
            awaiting_payment: "Đang chờ thanh toán",
            confirmed: "Đã Xác Nhận",
            ready: "Sẵn Sàng",
            on_route: "Đang Đi Giao",
            complete: "Hoàn Tất",
            cancelled: "Đã Hủy",
            seated: "Đã ngồi",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Chưa Có Sẵn",
                },
            },
            dish: {
                no_stock: "Tạm Hết Hàng",
                not_available: "Không Có Sẵn",
            },
        },
    },
};
//# sourceMappingURL=vi.js.map